import { CALL_MODES, CALL_TYPE } from '../constants';
import logger from '../../../Helpers/logger';

// import { logger } from '@/shared/utils';

let activeNotification = null;
let activeCallId = null;

export const requestNotificationPermission = () => {
    if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                logger.log('Notification permission granted');
            }
        });
    }
};

export const showIncomingCallNotification = (callData, users = {}) => {
    if (!('Notification' in window) || Notification.permission !== 'granted') {
        logger.warn('Browser notifications not supported or permission not granted');
        return;
    }

    // While tab is visible and focused, no need to show the notification
    if (document.visibilityState === 'visible' && document.hasFocus()) {
        logger.log('Tab is visible and focused, skipping browser notification');
        return;
    }

    const { from, callType, callMode, callId } = callData;
    const id = callId || from;

    // If notification for this call is already showing, ignore
    if (activeNotification && activeCallId === id) {
        logger.log('Notification already active for this callId:', id);
        return;
    }

    // Close existing notification if any
    if (activeNotification) {
        activeNotification.close();
    }
    activeCallId = id;
    const callerName = users[from]?.nickName || callData?.callerNickName;

    // Handle both uppercase (SDK) and lowercase (legacy) callTypes
    const isVideo = String(callType).toUpperCase() === CALL_TYPE.VIDEO;
    const isGroup = String(callMode).toUpperCase() === CALL_MODES.ONETOMANY;

    const typeStr = isVideo ? 'Video Call' : 'Audio Call';
    const title = isGroup ? `Incoming Group ${typeStr}` : `Incoming ${typeStr}`;
    const body = isGroup ? `Incoming call from ${callerName}` : `Incoming ${typeStr} from ${callerName}`;

    const options = {
        body,
        icon: `${window.location.origin}/logo192.png`,
        tag: 'incoming-call',
        requireInteraction: true, // Keep notification until user interacts or it's closed manually
    };

    activeNotification = new Notification(title, options);

    activeNotification.onclick = event => {
        event.preventDefault();
        window.focus();
        activeNotification.close();
        activeNotification = null;
        activeCallId = null;
    };

    activeNotification.onclose = () => {
        activeNotification = null;
        activeCallId = null;
    };
};

export const showMissedCallNotification = (callData, users = {}) => {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;

    // No need to show missed call if tab is focused
    if (document.visibilityState === 'visible' && document.hasFocus()) return;

    const { from, callType, callMode } = callData;
    const callerName = users[from]?.nickName || callData?.callerNickName || from;

    const isVideo = String(callType).toUpperCase() === CALL_TYPE.VIDEO;
    const isGroup = String(callMode).toUpperCase() === CALL_MODES.ONETOMANY;

    const typeStr = isVideo ? 'Video Call' : 'Audio Call';
    const title = `Missed ${isGroup ? 'Group ' : ''}${typeStr}`;
    const body = `You missed a call from ${callerName}`;

    const options = {
        body,
        icon: `${window.location.origin}/logo192.png`,
        tag: 'missed-call',
    };

    const notification = new Notification(title, options);

    notification.onclick = event => {
        event.preventDefault();
        window.focus();
        notification.close();
    };
};

export const closeIncomingCallNotification = () => {
    if (activeNotification) {
        activeNotification.close();
        activeNotification = null;
        activeCallId = null;
    }
};

export const isIncomingNotificationActive = () => !!activeNotification;
